export default __webpack_public_path__ + "static/planetside_div-e0278a66ffb982304d65d007bdaebc12.avif";